<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <div class="relative bg-gray-50 pt-16 pb-20 px-4 sm:px-6 lg:pt-24 lg:pb-28 lg:px-8">
        <div class="absolute">
            <div class="bg-white h-1/3 sm:h-2/3" />
        </div>
        <div class="relative max-w-7xl mx-auto">
            <div class="text-center">
                <h2 class="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl">{{translate('headline')}}</h2>
                <p class="mt-3 max-w-2xl mx-auto text-xl text-gray-500 sm:mt-4">{{translate('subline')}}</p>
            </div>
            <div class="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none">
                <div v-for="latestNft in latestNfts" :key="latestNft.id" class="flex flex-col rounded-lg shadow-lg overflow-hidden">
                    <div class="flex-shrink-0">
                        <a :href="latestNft.link" class="block mt-0 bg-white" target="_blank">
                        <img class="h-48 w-full object-contain" :src="latestNft.image" alt="" />
                        </a>
                    </div>
                    <div class="flex-1 bg-white p-6 flex flex-col justify-between">
                        <div class="flex-1">
                            <a :href="latestNft.link" class="block mt-0" target="_blank">
                                <p class="text-sm text-gray-900 font-semibold">
                                    {{ latestNft.name }}
                                </p>
                            </a>
                        </div>
                        <div class="mt-6 flex items-center">
                            <div class="flex-shrink-0">
                                <a :href="latestNft.link" target="_blank">
                                    <span class="sr-only">Polygon</span>
                                    <img class="h-10 w-10" src="/img/polygon-matic-logo.svg" alt="" />
                                </a>
                            </div>
                            <div class="ml-3">
                                <p class="text-sm font-medium text-gray-900">
                                    <a :href="latestNft.link" class="hover:underline" target="_blank">
                                        Polygon
                                    </a>
                                </p>
                                <div class="flex space-x-1 text-sm text-gray-500">
                                    <time :datetime="latestNft.date">
                                        {{latestNft.date}}
                                    </time>
                                    <span aria-hidden="true"> &middot; </span>
                                    <span> Block {{ latestNft.block }} </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {computed} from "vue";
import {usePage} from "@inertiajs/inertia-vue3";
import translate from "../../lang";

export default {
    setup() {
        const latestNfts = computed(() => usePage().props.value.latestNfts)

        return {
            latestNfts,
            translate: translate('latest')
        }
    },
}
</script>
